import { Stack, Typography, useTheme } from "@mui/material";
import { Icon } from "@iconify/react";

import { useResponsive } from "@app/hooks";

interface CustomStepperHeaderProps {
  activeStep: number;
  headersSteps: {
    label: string;
    icon?: string;
    text?: string;
  }[];
  onStepClick?: any;
}

const StepperHeader = ({
  activeStep,
  headersSteps,
  onStepClick,
}: CustomStepperHeaderProps) => {
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      px={{ xs: 1, sm: 3, md: 4 }}
      my={4}
    >
      {headersSteps?.map((step: any, index: any) => {
        const isCompleted = index < activeStep;
        const isActive = index === activeStep;

        return (
          <Stack
            key={index}
            textAlign="center"
            flex={1}
            position="relative"
            alignItems="center"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => onStepClick(index)}
          >
            <Stack
              sx={{
                backgroundColor:
                  isCompleted || isActive
                    ? theme.palette.primary.main
                    : theme.palette.grey[200],
                width: isMobile ? 30 : 40,
                height: isMobile ? 30 : 40,
                borderRadius: "50%",
                mx: "auto",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2,
                position: "relative",
              }}
            >
              {step.icon && (
                <Icon
                  icon={step.icon}
                  color={
                    isActive || isCompleted ? "white" : theme.palette.grey[500]
                  }
                  width={20}
                  height={20}
                />
              )}
              {!step.icon && step.text && (
                <Typography
                  variant="caption"
                  sx={{
                    color:
                      isActive || isCompleted
                        ? "white"
                        : theme.palette.grey[500],
                    fontWeight: 600,
                    fontSize: isMobile ? "0.7rem" : "0.85rem",
                  }}
                >
                  {step.text}
                </Typography>
              )}
            </Stack>

            <Typography
              variant="caption"
              sx={{
                fontSize: { xs: "0.6rem", sm: "0.75rem" },
                textAlign: "center",
                mt: 1,
                maxWidth: 82,
                mx: "auto",
                wordBreak: "break-word",
                fontFamily: "Work Sans",
                fontWeight: "500",
                color: theme.palette.grey[600],
              }}
            >
              {step?.label}
            </Typography>

            {index < headersSteps?.length - 1 && (
              <Stack
                sx={{
                  position: "absolute",
                  top: isMobile ? 14 : 18,
                  left: "50%",
                  width: "100%",
                  height: 2,
                  backgroundColor:
                    index < activeStep
                      ? theme.palette.primary.main
                      : theme.palette.grey[200],
                  zIndex: 1,
                }}
              />
            )}
          </Stack>
        );
      })}
    </Stack>
  );
};

export { StepperHeader };
